import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../api';
import { PaymentPollingDto } from '../../generated-api';

export const usePollPaymentStatusList = (
  paymentReferences: Array<string>,
  enabled: boolean,
  onSuccess: (data: PaymentPollingDto[]) => void
) => {
  const apiClient = useApiClient();
  return useQuery({
    queryKey: ['polling', [...paymentReferences].sort().join(',')],

    queryFn: async () => {
      const response = await apiClient.PaymentPollingController.getPaymentStatusList(
        { references: paymentReferences },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      onSuccess(response);
      return response;
    },
    refetchInterval: 5000,
    enabled,
  });
};
